import { ICreateDisputeInputs } from '@clients/disputesClient';
import { TransactionItem } from '@clients/transactionsClient';
import getModalityValues from '@components/transactions/reportDisputeDialog/getModalityValues';
import { ModalityOption } from '@datasets/Modality';

interface constructDataToSendProps {
    data: ICreateDisputeInputs;
    transaction: TransactionItem;
    transactionAmount: number;
    protocol: string;
    programModalityReasons: ModalityOption[];
}
const constructDataToSend = ({
    data,
    transaction,
    transactionAmount,
    protocol,
    programModalityReasons,
}: constructDataToSendProps) => {
    data = {
        ...data,
        modality: getModalityValues(data.modality, programModalityReasons),
    };
    // arn is not required if authorization id is present
    if (transaction?.authorization?.id != null) {
        delete data.arn;
    }
    // don't send empty field to API (yup validation ensures this is populated if required)
    if (data.dispute_due_to === '') {
        delete data.dispute_due_to;
    }
    // if the transaction has an authorization id send it
    const hiddenFields = {
        ...(!!transaction?.authorization?.id && {
            authorization_id: transaction?.authorization.id,
        }),
        // if the operator session protocol is available send it
        ...(!!protocol && { protocol: protocol }),
        // if there is a no transaction authorization id we need to send the transaction date
        ...(!transaction?.authorization?.id && {
            transaction_date: transaction?.created_at,
        }),
        // if the disputed amount is less than the transaction then it is a partial dispute
        is_partial: data.amount < transactionAmount,
    };

    return { ...data, ...hiddenFields };
};

export default constructDataToSend;
